import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router';
import { useCallback, useState } from 'react';
import { getModule } from '@jwp/ott-common/src/modules/container';
import { useAccountStore } from '@jwp/ott-common/src/stores/AccountStore';
import AccountController from '@jwp/ott-common/src/controllers/AccountController';

import Button from '../Button/Button';
import { modalURLFromLocation } from '../../utils/location';

import styles from './SsoInvalidToken.module.scss';

const SsoInvalidToken = () => {
  const accountController = getModule(AccountController);

  const { t } = useTranslation(['user', 'common']);
  const navigate = useNavigate();
  const location = useLocation();

  const handleCancel = useCallback(() => {
    navigate('/');
  }, [location, navigate]);

  return (
    <div className={styles.formContainer}>
      <h2 className={styles.heading}>{t('user:profile.invalid_token')}</h2>
      <p className={styles.paragraph}>{t('user:profile.invalid_token_content')}</p>
      <div className={styles.passwordButtonsContainer}>
        <Button type="submit" onClick={handleCancel} className={styles.button} color="primary" fullWidth label={t('common:alert.close')} />
      </div>
    </div>
  );
};

export default SsoInvalidToken;
